// extracted by mini-css-extract-plugin
export default {"container":"create-deal-modal-component_container__pRyWC","truncate-table":"create-deal-modal-component_truncate-table__sCuT-","table-text-faded":"create-deal-modal-component_table-text-faded__GYLAJ","form":"create-deal-modal-component_form__PVQXa","buttons":"create-deal-modal-component_buttons__TYjbv"};
    if(module.hot) {
      // 1792500653979
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  